export default __webpack_public_path__ + "static/media/background-breeding.b129bcc2.png";